<template>
    <div class="row" v-if="goal && goal.domain">
        <div class="col-12 col-sm-9 px-3">
            <div
                class="widget h-100 d-flex flex-column justify-content-start align-items-start px-1 px-md-3 py-1 py-md-3 m-1"
            >
                <template v-if="!editing">
                    <h6
                        :style="`color: ${goal.domain.color}`"
                        class="font-weight-bold text-uppercase"
                    >
                        {{ goal.domain.name }} goal:
                    </h6>
                    <h5 class="mb-0">{{ goal.title }}</h5>
                    <span class="d-flex align-items-center small text-muted mb-0">
                        <em class="mr-2"
                            >goal created: {{ moment(goal.created_at).format("MMMM DD, YYYY") }}
                            {{ goal.created_by_user ? `by ${goal.created_by_user.name}` : "" }}</em
                        >
                        <profile-picture
                            v-if="goal.created_by_user"
                            :name="goal.created_by_user.name"
                            :size="'sm'"
                            :url="goal.created_by_user.profile_photo_url"
                        ></profile-picture
                        ><span>
                            <i
                                class="fa text-primary ml-2"
                                v-tooltip="goal.is_shared ? 'This is a shared goal' : null"
                                :class="goal.is_shared ? 'fa-users' : 'fa-fw'"
                            ></i>
                        </span>
                    </span>
                    <hr
                        class="my-3"
                        style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 1rem;"
                    />
                    <p>{{ goal.description }}</p>
                    <hr
                        class="my-3"
                        style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 1rem;"
                    />
                    <p class="font-weight-bold text-uppercase">
                        Steps:
                    </p>
                    <ol class="px-3">
                        <li class="mb-0" v-for="step in helpers._get(goal, 'parameters.steps', [])">
                            {{ step }}
                        </li>
                    </ol>
                </template>
                <template v-else="">
                    <h6
                        :style="`color: ${goal.domain.color}`"
                        class="font-weight-bold text-uppercase"
                    >
                        {{ goal.domain.name }} goal:
                    </h6>
                    <input v-model="edited.title" class="mb-0" style="width:100%" />
                    <small class="text-muted mb-0"
                        ><em
                            >goal created: {{ moment(goal.created_at).format("MMMM DD, YYYY") }}</em
                        ></small
                    >
                    <hr
                        style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 1rem;"
                    />
                    <textarea style="width:100%" v-model="edited.description" />
                    <hr
                        class="my-3"
                        style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 1rem;"
                    />
                    <div class="d-flex">
                        <span class="">Success: </span
                        ><input
                            v-model.number="edited.parameters.success"
                            name="success"
                            type="text"
                            class="d-inline form-control form-control-sm"
                            style="max-width: 3rem; line-height: 0.5;"
                        /><span class="">%</span>
                    </div>

                    <hr
                        class="my-3"
                        style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 1rem;"
                    />
                    <h6 class="font-weight-bold text-uppercase">
                        Add, remove, rename or reorder steps:
                    </h6>
                    <draggable v-model="steps" class="w-100">
                        <transition-group>
                            <div
                                v-for="(step, index) in steps"
                                :key="step"
                                class="d-flex w-100 justify-content-between align-items-center"
                            >
                                <div class="badge badge-primary mr-3">
                                    {{ ("0" + (index + 1)).slice(-2) }}
                                </div>
                                <div class="card w-100 m-1" style="cursor: grab;">
                                    <div class="card-body p-2">
                                        <div class="w-100 d-flex align-items-center">
                                            <i class="fa fa-align-justify mr-3"></i>
                                            <span>{{ step }}</span>
                                            <button
                                                class="btn btn-sm btn-outline-info ml-auto"
                                                v-tooltip="'Rename step'"
                                                @click="renameStep(index)"
                                            >
                                                <i class="fa fa-edit"></i>
                                            </button>
                                            <button
                                                class="btn btn-sm btn-outline-danger ml-3"
                                                v-tooltip="'Remove step'"
                                                @click="removeStep(index)"
                                            >
                                                <i class="fa fa-trash-o"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </draggable>
                    <div class="w-100 text-right">
                        <button
                            class="btn btn-sm btn-outline-primary"
                            slot="footer"
                            @click="addStep"
                        >
                            Add step
                        </button>
                    </div>
                </template>

                <div class="w-100 d-flex justify-content-end mt-3">
                    <template v-if="editing">
                        <button
                            @click="editDescription()"
                            style="top:1rem; right:2rem"
                            class="text-uppercase font-weight-bold btn btn-sm btn-link text-muted"
                        >
                            Cancel
                        </button>
                        <button
                            @click="updateGoal()"
                            style="top:1rem; right:7rem"
                            class="text-uppercase font-weight-bold btn btn-sm btn-primary"
                        >
                            <i class="fa fa-save mr-1"> </i>Save
                        </button>
                    </template>
                    <template v-else="">
                        <button
                            v-if="userCanEditGoal"
                            @click="editDescription()"
                            style="top:1rem; right:2rem"
                            class="text-uppercase font-weight-bold btn btn-sm btn-primary"
                        >
                            <i class="fa fa-edit mr-2 text-white"></i>Edit
                        </button>
                    </template>
                </div>
            </div>
            <modal-component
                :id="'rename-step'"
                :noclose="true"
                :visible="renameStepIndex"
                @close="closeRenameStep()"
            >
                <div class="d-flex w-100 justify-content-between p-3">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="steps[renameStepIndex]"
                    />
                    <button class="btn btn-sm btn-outline-primary ml-3" @click="closeRenameStep()">
                        <i class="fa fa-check"></i>
                    </button>
                </div>
            </modal-component>
        </div>
        <div class="col-12 col-sm-3">
            <div class="d-flex flex-column h-100">
                <div class="flex-grow-1 mb-3">
                    <goals-average-score
                        :goal="goal"
                        :title="'Progress average'"
                        :progress="helpers._get(goal, 'progress', 0)"
                        :show-info="true"
                    ></goals-average-score>
                </div>
                <div class="flex-grow-1 mt-3">
                    <goals-progress :goal="goal" :stats="stats"></goals-progress>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import ModalComponent from "../ui/ModalComponent";
import GoalsAverageScore from "./GoalsAverageScore";
import GoalsProgress from "./GoalsProgress";
import ProfilePicture from "../ui/ProfilePicture";
import { helpers } from "../../plugins/helpers";

export default {
    name: "DescriptionTaskAnalysis",
    props: ["goal", "userCanEditGoal", "stats"],
    components: {
        draggable,
        ModalComponent,
        GoalsAverageScore,
        GoalsProgress,
        ProfilePicture,
    },
    data() {
        return {
            helpers,
            editing: false,
            edited: {},
            steps: [],
            renameStepIndex: null,
        };
    },
    methods: {
        editDescription() {
            if (this.editing) {
                this.editing = false;
            } else {
                this.editing = true;
                this.edited = this.goal;
                this.steps = _.get(this.goal, "parameters.steps", []);
            }
        },
        addStep() {
            this.steps.push("New step");
        },
        removeStep(index) {
            this.steps.splice(index, 1);
        },
        renameStep(index) {
            this.renameStepIndex = index;
        },
        closeRenameStep() {
            this.renameStepIndex = null;
        },
        updateGoal() {
            this.edited.parameters.steps = [...this.steps];
            axios
                .patch(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}`, this.edited)
                .then(response => {
                    this.$emit("refresh-goals");
                    this.editing = false;
                    this.edited = {};
                });
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
}
</style>
